// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_zXm5G","item_wrap":"item_wrap_QRGJe","item_tag":"item_tag_5YPNh","item_1":"item_1_6TbLk","item_2":"item_2_ARW3H","item_3":"item_3_vwFKm"};